import { TreatmentListEntity } from "@/domain/entity/treatment/treatment-list-entity";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchTreatmentListUsecase {
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  async execute(patientUuid: string): Promise<SATResult<TreatmentListEntity, SATError>> {
    return this.treatmentRepo.fetchTreatmentList(patientUuid);
  }
}
